// /* eslint-disable */
import React, { useEffect, useState } from "react";
import ResourceBasicScheduler from "../ReactBigCalendar/ResourceBasicScheduler";
import apiHandler from "../../common/api";
import { Offcanvas, Button, Form, Modal } from "react-bootstrap";

import moment from "moment";
import Trash from "feather-icons-react/build/IconComponents/Trash";
import { Info, PlusCircle } from "feather-icons-react/build/IconComponents";
import StaffRegularShift from "./StaffRegularShift";
import DatePickup from "../DatePickup/DatePickup";
import { dateFormat } from "../../common/common";
import AddStaffBloackBreakTIme from "./AddStaffBloackBreakTIme";

function BusinessHoursTeamShiftManage({
  minHoursDropdown,
  businessId,
  userData,
  daysDropdown,
  staffApiRefresh
}) {
  // const [startDate, setStartDate] = useState(moment().startOf('week').format('YYYY-MM-DD'));
  // const [endDate, setEndDate] = useState(moment().endOf('week').format('YYYY-MM-DD'));

  const [calendarDate, setCalendarDate] = useState({
    startDate: moment().startOf("week").format("YYYY-MM-DD"),
    endDate: moment().endOf("week").format("YYYY-MM-DD"),
  });
  const [teamList, setTeamList] = useState([]);
  const [eventsList, setEventsList] = useState([]);
  const [businessHolidays, setBusinessHolidays] = useState([]);
  const [staffHolidays, setStaffHolidays] = useState([]);
  const [schedulerData, setSchedulerData] = useState([]);
  const [addEventData, setAddEventData] = useState({ id: 0 ,start : moment().format("YYYY-MM-DD")});
  const [showAddEventModel, setShowAddEventModel] = useState(false);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [shiftByTillDateList, setShiftByTillDateList] = useState([]);

  const addEventTypeList = [
    // { id: 1, name: "Add Shift" },
    // { id: 2, name: "Add regular shifts" },
    // { id: 3, name: "Add time off" },
    { id: 1, name: "Manage Staff Shift" },
    { id: 2, name: " Manage Staff Shift by Day Wise" },
    { id: 3, name: "Manage Blocked Time Cycle" },
  ];

  console.log(eventsList, "eventsList");
  console.log(schedulerData, "schedulerData");

  // const resources = [
  //   { id: "r0", name: "Resource0", title: "Resource 0", groupOnly: true },
  //   { id: "r1", name: "Resource1", title: "Resource 1", parentId: "r0" },
  //   { id: "r2", name: "Resource2", parentId: "r3" },
  //   { id: "r3", name: "Resource3", parentId: "r1" },
  //   { id: "r4", name: "Resource4" },
  //   { id: "r5", name: "Resource5" },
  //   { id: "r6", name: "Resource6" },
  //   { id: "r7", name: "Resource7" },
  // ];

  // const events = [
  //   {
  //     id: 1,
  //     start: "2025-03-18 09:30:00",
  //     end: "2025-03-18 23:30:00",
  //     resourceId: 58,
  //     title: "I am finished",
  //     bgColor: "#D9D9D9",
  //     showPopover: false,
  //   },
  //   {
  //     id: 2,
  //     start: "2025-03-19 12:30:00",
  //     end: "2025-03-19 23:30:00",
  //     resourceId: 47,
  //     title: "I am not resizable",
  //     resizable: false,
  //   },
  //   {
  //     id: 3,
  //     start: "2022-12-19 12:30:00",
  //     end: "2022-12-20 23:30:00",
  //     resourceId: "r3",
  //     title: "I am not movable",
  //     movable: false,
  //   },
  //   {
  //     id: 4,
  //     start: "2022-12-19 14:30:00",
  //     end: "2022-12-20 23:30:00",
  //     resourceId: "r4",
  //     title: "I am not start-resizable",
  //     startResizable: false,
  //   },
  //   {
  //     id: 5,
  //     start: "2022-12-19 15:30:00",
  //     end: "2022-12-20 23:30:00",
  //     resourceId: "r5",
  //     title: "I am not end-resizable",
  //     endResizable: false,
  //   },
  //   {
  //     id: 6,
  //     start: "2022-12-19 15:35:00",
  //     end: "2022-12-19 23:30:00",
  //     resourceId: "r6",
  //     title: "I am normal",
  //   },
  //   {
  //     id: 7,
  //     start: "2022-12-19 15:40:00",
  //     end: "2022-12-20 23:30:00",
  //     resourceId: "r7",
  //     title: "I am exceptional",
  //     bgColor: "#FA9E95",
  //   },
  //   {
  //     id: 8,
  //     start: "2022-12-19 15:50:00",
  //     end: "2022-12-19 23:30:00",
  //     resourceId: "r1",
  //     title: "I am locked",
  //     movable: false,
  //     resizable: false,
  //     bgColor: "red",
  //   },
  //   {
  //     id: 9,
  //     start: "2022-12-19 16:30:00",
  //     end: "2022-12-27 23:30:00",
  //     resourceId: "r1",
  //     title: "R1 has many tasks 1",
  //   },
  //   {
  //     id: 10,
  //     start: "2022-12-19 17:30:00",
  //     end: "2022-12-19 23:30:00",
  //     resourceId: "r1",
  //     title: "R1 has recurring tasks every week on Tuesday, Friday",
  //     rrule: "FREQ=WEEKLY;DTSTART=20221219T013000Z;BYDAY=TU,FR",
  //     bgColor: "#f759ab",
  //   },
  //   {
  //     id: 11,
  //     start: "2022-12-19 18:30:00",
  //     end: "2022-12-20 23:30:00",
  //     resourceId: "r1",
  //     title: "R1 has many tasks 3",
  //   },
  //   {
  //     id: 12,
  //     start: "2022-12-20 18:30:00",
  //     end: "2022-12-20 23:30:00",
  //     resourceId: "r1",
  //     title: "R1 has many tasks 4",
  //   },
  //   {
  //     id: 13,
  //     start: "2022-12-21 18:30:00",
  //     end: "2022-12-24 23:30:00",
  //     resourceId: "r1",
  //     title: "R1 has many tasks 5",
  //   },
  //   {
  //     id: 14,
  //     start: "2022-12-23 18:30:00",
  //     end: "2022-12-27 23:30:00",
  //     resourceId: "r1",
  //     title: "R1 has many tasks 6",
  //   },
  // ];

  const getAllTeamData = async (bId) => {
    try {
      const { ResponseCode, ResponseData } = await apiHandler({
        method: "GET",
        route: `Superadmin/TeamListbybusinessId?businessId=${bId}`,
      });

      if (ResponseCode !== "SUCCESS")
        throw new Error("Failed to fetch team list");

      const finalData = ResponseData?.map((team) => ({
        ...team,
        name: team?.fullName,
        title: team?.fullName,
      }));
      setTeamList(finalData);
    } catch (error) {
      console.error("Error fetching team data:", error);
    }
  };

  useEffect(() => {
    if (businessId) {
      getAllTeamData(businessId);
    }
  }, [businessId]);

  const getAllEventsData = async (bId) => {
    console.log(
      calendarDate?.endDate,
      calendarDate?.startDate,
      teamList,
      "startDate"
    );
    try {

      const responseData = await apiHandler({
        method: "GET",
        route: `Business/TeamShiftSchedulebybusinessId?businessId=${bId}&startDate=${calendarDate?.startDate}&endDate=${calendarDate?.endDate}`,
      });

      if (responseData?.ResponseCode !== "SUCCESS") {
        console.error("Failed to fetch team list:", responseData);
        return;
      }

      const finalData = responseData?.ResponseData?.events?.map((event) => {
        let title = `${event?.startTime} - ${event?.endTime}`;

        if (event?.type == 3 && event?.dayOff == 1) {
          title = `${event?.breakName}: ${event?.breakeTitle}`;
        } else if (event?.type == 3 && event?.dayOff == 0) {
          title = `${event?.breakName || "Custom"}: ${event?.breakeTitle} ${event?.startTime} - ${event?.endTime}`;
        }

        return {
          id: event?.id,
          start: `${event?.daydate} ${event?.startTime}`,
          end: `${event?.daydate} ${event?.endTime}`,
          resourceId: event?.staffId,
          date: event?.daydate,
          title: title,
          bgColor: "var(--bs-orange)",
          type: event?.type,
          resizable: false,
          showPopover: false,
          description: event?.description || "",
          isApproved: event?.isApproved || 0,
          breakeTitle: event?.breakeTitle || "",
          breaktype: event?.breaktype || 0,
          isDayOff: event?.dayOff || 0,
        };
      });

      console.log(finalData, "finalData");
      setEventsList(finalData);
      setBusinessHolidays(responseData?.ResponseData?.businessHoliday);
      setStaffHolidays(responseData?.ResponseData?.staffOnHoliday);
    } catch (error) {
      console.error("Error fetching service data:", error);
    }
  };

  console.log(teamList, "teamList");

  const callBackNextClick = (data) => {
    setCalendarDate({
      startDate: moment(data?.startDate?.$d).format("YYYY-MM-DD"),
      endDate: moment(data?.endDate?.$d).format("YYYY-MM-DD"),
    });
  };

  const callBackPrevClick = (data) => {
    setCalendarDate({
      startDate: moment(data?.startDate?.$d).format("YYYY-MM-DD"),
      endDate: moment(data?.endDate?.$d).format("YYYY-MM-DD"),
    });
  };

  const callbackSchedulerData = (data) => {
    setSchedulerData(data);
  };

  const callBackAddEvent = (data) => {
    console.log(data, "callBackAddEvent");
    const eventDate = moment(data?.start).format("YYYY-MM-DD");

    // Check if the clicked date is disabled
    if (businessHolidays?.includes(eventDate)) {
      return;
    }

    console.log(staffHolidays, "callBackAddEvent");
    if (
      staffHolidays.some(
        (holiday) => holiday.staffId == data?.slotId && holiday.daydate == eventDate
      )
    ) {
      return;
    }

    setShowAddEventModel(true);
    setAddEventData({
      ...data,
      id: 0,
      resourceId: data?.slotId,
      slotName: teamList?.find((el) => el.id === data?.slotId)?.fullName,
    });
  };

  const callBackEventClicked = (data) => {
    console.log(data, "callBackEventClicked");
    setAddEventData({
      ...data,
      slotName: teamList?.find((el) => el.id === data?.resourceId)?.fullName,
    });

    const updatedShifts = eventsList
      ?.filter(
        (ev) =>
          ev?.date === data?.date &&
          ev?.type == data?.type &&
          ev?.resourceId == data?.resourceId
      )
      .map((ev) => ({
        ...ev,
        start: moment(ev.start).format("HH:mm"),
        end: moment(ev.end).format("HH:mm"),
        date: moment(ev?.date).format("YYYY-MM-DD"),
        dayId: moment(ev?.date).isoWeekday(),
      }));

    console.log(updatedShifts, "updatedShifts");
    setShifts(updatedShifts);

    setShowOffcanvas(true);
  };

  useEffect(() => {
    getAllEventsData(businessId);
  }, [businessId, calendarDate, staffApiRefresh]);

  console.log(addEventData, showAddEventModel, "showAddEventModel");
  // console.log(schedulerData, eventsList, "schedulerData");

  const handleShowOffCover = (id, name) => {
    setShowAddEventModel(false);
    setShowOffcanvas(true);
    if (id === 1) {
      const updatedShifts = eventsList
        ?.filter(
          (ev) =>
            ev?.date == moment(addEventData?.start).format("YYYY-MM-DD") &&
            ev?.type == 1 &&
            ev?.resourceId == addEventData?.slotId
        )
        .map((ev) => ({
          ...ev,
          start: moment(ev.start).format("HH:mm"),
          end: moment(ev.end).format("HH:mm"),
          date: ev?.date,
          dayId: moment(ev?.date).isoWeekday(),
        }));

      setShifts(updatedShifts);
    }
    setAddEventData((prev) => {
      return {
        ...prev,
        type: id,
        typeName: name,
        tillDate: moment(addEventData?.start).format("YYYY-MM-DD"),
        date: moment(addEventData?.start).format("YYYY-MM-DD"),
      };
    });
  };

  // daysDropdown
  const [shifts, setShifts] = useState([
    {
      start: "09:00",
      end: "17:00",
      id: 0,
      dayId: moment(addEventData?.start).isoWeekday(),
      date: moment(addEventData?.start).format("YYYY-MM-DD"),
      isOverLapping: 0,
    },
  ]);

  const checkOverlap = (newShift, existingShifts, singleDateWise = true) => {
    console.log(newShift, existingShifts, "checktheoverlapping");

    const checkData = existingShifts.some((shift) => {
      const isSameDate = singleDateWise ? shift.date === newShift.date : true;

      return (
        isSameDate &&
        ((newShift.start >= shift.start && newShift.start < shift.end) || // New shift starts within another shift
          (newShift.end > shift.start && newShift.end <= shift.end) || // New shift ends within another shift
          (newShift.start <= shift.start && newShift.end >= shift.end)) // New shift fully covers another shift
      );
    });

    console.log(checkData, "checkData");
    return checkData;
  };

  const handleAddShift = () => {
    const newShift = {
      start: "09:00",
      end: "17:00",
      id: 0,
      dayId: moment(addEventData?.start).isoWeekday(),
      date: moment(addEventData?.start).format("YYYY-MM-DD"),
      isOverLapping: 0,
    };

    newShift.isOverLapping = checkOverlap(newShift, [
      ...shifts,
      ...shiftByTillDateList,
    ])
      ? 1
      : 0;
    setShifts([...shifts, newShift]);
  };

  const handleDeleteShift = (index, shift) => {
    const updatedShifts = shifts.filter((_, i) => i !== index);

    const updateTillDateData = shiftByTillDateList?.map((prev) => {
      if (prev.start === shift.start && prev.end === shift.end) {
        return { ...prev, isOverLapping: 0 };
      } else {
        return prev;
      }
    });

    setShifts(updatedShifts);
    setShiftByTillDateList(updateTillDateData);
  };

  const handleCloseOffCover = () => {
    setShowOffcanvas(false);
    setShifts([
      {
        start: "09:00",
        end: "17:00",
        id: 0,
        date: moment(addEventData?.start).format("YYYY-MM-DD"),
        isOverLapping: 0,
      },
    ]);
    setAddEventData({ id: 0 });
    setShiftByTillDateList([]);
    getAllEventsData(businessId);
  };

  const handleShiftChange = (index, type, value) => {
    // Clone and update the specific shift's field
    const updatedShifts = [...shifts];
    updatedShifts[index] = { ...updatedShifts[index], [type]: value };

    // Check overlap for current shift
    const isOverlap = checkOverlap(updatedShifts[index], [
      ...shifts.filter((_, i) => i !== index),
      ...shiftByTillDateList,
    ])
      ? 1
      : 0;

    updatedShifts[index].isOverLapping = isOverlap;

    const updatedLocalShifts = updatedShifts.map((shift, inx) => {
      const isOverlap = checkOverlap(
        shift,
        [...updatedShifts, ...shiftByTillDateList].filter((_, i) => i !== inx),
        false
      )
        ? 1
        : 0;

      return { ...shift, isOverLapping: isOverlap };
    });

    const updatedApiShifts = shiftByTillDateList.map((shift) => {
      const isOverlap = checkOverlap(
        shift,
        updatedLocalShifts, // Exclude the current shift
        false // Ignore date matching for cross-date checks
      )
        ? 1
        : 0;

      console.log(shift.date, isOverlap, "API shift overlap check");
      return { ...shift, isOverLapping: isOverlap };
    });

    setShiftByTillDateList(updatedApiShifts);
    setShifts(updatedLocalShifts);
  };

  const calculateTotalHours = () => {
    return shifts
      .reduce((total, shift) => {
        const start = moment(shift.start, "HH:mm");
        const end = moment(shift.end, "HH:mm");
        return total + (end.diff(start, "hours", true) || 0);
      }, 0)
      .toFixed(2);
  };

  const generateShiftsForRange = (shifts, startDate, tillDate) => {
    if (tillDate) {
      const start = moment(startDate);
      const end = moment(tillDate);
      const generatedShifts = [];

      // Loop through each date from startDate to tillDate
      while (start.isSameOrBefore(end, "day")) {
        const dayId = start.isoWeekday(); // Get dayId (1 = Monday, 7 = Sunday)

        // Clone the shifts for this date
        shifts.forEach((shift) => {
          generatedShifts.push({
            ...shift,
            date: start.format("YYYY-MM-DD"),
            dayId,
            id: 0, // Ensure new shifts are marked with id 0 for backend processing
          });
        });

        // Move to the next day
        start.add(1, "day");
      }

      return [...generatedShifts, ...shiftByTillDateList];
    } else {
      return shifts;
    }
  };

  const handleUpsertForStaff = async () => {
    const hasOverlap = shifts.some((shift) => shift.isOverLapping);
    if (hasOverlap) {
      alert("One or more shifts are overlapping. Please fix the conflicts.");
      return;
    }

    try {
      const payloadData = {
        // ...addEventData,
        shifts: generateShiftsForRange(
          shifts,
          addEventData?.start,
          addEventData.tillDate
        ),
        businessId,
        // dayId: moment(addEventData?.start).isoWeekday(),
        date: moment(addEventData?.start).format("YYYY-MM-DD"),
        isDayOff: 0,
        tillDate: addEventData?.tillDate,
        loginuserid: userData?.id,
        staffId: addEventData?.resourceId,
        type: addEventData?.type,
      };

      console.log(payloadData, "payloadData");

      const responseData = await apiHandler({
        method: "POST",
        route: `Business/TeamShiftScheduleUpsert?businessId=${businessId}`,
        payload: payloadData,
      });

      if (responseData?.ResponseCode !== "SUCCESS") {
        console.error("Failed to fetch team list:", responseData);
        return;
      }
      handleCloseOffCover();
    } catch (error) {
      console.error("Error fetching service data:", error);
    }
  };

  const handleDeleteTeamShiftByDate = async () => {
    try {
      const responseData = await apiHandler({
        method: "POST",
        route: `Business/TeamShiftDeleteByDate`,
        payload: {
          id: 0, // we are deleted by the date and type
          businessId,
          date: addEventData?.date,
          type: 1,
          loginuserid: userData?.id,
        },
      });

      if (responseData?.ResponseCode !== "SUCCESS") {
        console.error("Failed to fetch team list:", responseData);
        return;
      }
      handleCloseOffCover();
    } catch (error) {
      console.error("Error fetching service data:", error);
    }
  };

  const getStaffDataByTillDate = async (tillDate) => {
    try {
      const { ResponseCode, ResponseData } = await apiHandler({
        method: "GET",
        route: `Business/TeamShiftByTillDate?businessId=${businessId}&resourceId=${addEventData?.resourceId}&tillDate=${tillDate}`,
      });

      if (ResponseCode !== "SUCCESS")
        throw new Error("Failed to fetch team list");

      // Merge local shifts and API shifts
      const mergedShifts = [...shifts, ...ResponseData];

      // Check overlaps for API shifts against local and API data (excluding self)
      const updatedApiShifts = ResponseData.map((shift) => {
        const isOverlap = checkOverlap(
          shift,
          shifts, // Exclude the current shift
          false // Ignore date matching for cross-date checks
        )
          ? 1
          : 0;

        console.log(shift.date, isOverlap, "API shift overlap check");
        return { ...shift, isOverLapping: isOverlap };
      });

      // Update local shifts too with overlaps
      const updatedLocalShifts = shifts.map((shift, index) => {
        const isOverlap = checkOverlap(
          shift,
          mergedShifts.filter((_, i) => i !== index),
          false
        )
          ? 1
          : 0;

        console.log(shift.date, isOverlap, "Local shift overlap check");
        return { ...shift, isOverLapping: isOverlap };
      });

      // Update state with validated API data and local shifts
      setShiftByTillDateList(updatedApiShifts);
      setShifts(updatedLocalShifts);
    } catch (error) {
      console.error("Error fetching team data:", error);
    }
  };

  const handelTillDateChnage = (tDate) => {
    setAddEventData((prev) => ({
      ...prev,
      tillDate: moment(tDate).format("YYYY-MM-DD"),
    }));
    getStaffDataByTillDate(moment(tDate).format("YYYY-MM-DD"));
  };

  console.log(shifts, shiftByTillDateList, "shiftByTillDateList");
  // console.table(shiftByTillDateList);
  return (
    <div>
      {teamList.length > 0 ? ( // && eventsList.length > 0
        <ResourceBasicScheduler
          resources={teamList}
          events={eventsList}
          callBackNextClick={callBackNextClick}
          callBackPrevClick={callBackPrevClick}
          callbackSchedulerData={callbackSchedulerData}
          callBackAddEvent={callBackAddEvent}
          callBackEventClicked={callBackEventClicked}
        />
      ) : (
        <p>Need to Add Staff First</p>
      )}

      <Modal
        show={showAddEventModel}
        onHide={() => setShowAddEventModel(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Add {addEventData?.slotName} Add shifts for
            {" " + dateFormat(addEventData?.start)}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul className="list-unstyled">
            {addEventTypeList?.map((event, index) => (
              <li
                key={index}
                onClick={() => handleShowOffCover(event?.id, event?.name)}
              >
                <Button variant="primary" className="w-100 mb-2">
                  {event?.name}
                </Button>
              </li>
            ))}
          </ul>
        </Modal.Body>
      </Modal>

      <Offcanvas
        show={showOffcanvas}
        onHide={() => handleCloseOffCover()}
        placement="end"
        backdrop="static"
        style={{ width: "1000px" }}
      >
        {/* this is date wise Shift */}
        {addEventData?.type == 1 && (
          <>
            <Offcanvas.Header closeButton>
              <Offcanvas.Title className="text-lg font-semibold">
                {addEventData?.slotName} shift {dateFormat(addEventData?.start)}
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="p-4" style={{ width: "600px" }}>
              <Form className="space-y-3">
                {/* Select Till Date  */}
                <Form.Group
                  controlId={`startTime`}
                  className="d-flex align-items-center  custome-border-bottom mb-2  col-12 gap-2"
                >
                  <Form.Label className="fw-medium">Till Date</Form.Label>
                  <DatePickup
                    filterDate={addEventData?.tillDate}
                    // showDefaultDate={true}
                    handleDateChange={(e) => handelTillDateChnage(e)}
                  />
                </Form.Group>
                {shifts.map((shift, index) => (
                  <div
                    key={index}
                    className=" custome-border-bottom mb-2  d-flex align-items-center gap-3 mb-2"
                  >
                    {/* Start Time */}
                    <Form.Group
                      controlId={`startTime-${index}`}
                      className="d-flex flex-column col-md-5"
                    >
                      <Form.Label className="fw-medium">Start time</Form.Label>
                      <Form.Select
                        value={shift.start}
                        onChange={(e) =>
                          handleShiftChange(index, "start", e.target.value)
                        }
                        className="form-select"
                      >
                        {minHoursDropdown.map((min, i) => (
                          <option key={i} value={min.value}>
                            {min.label}
                          </option>
                        ))}
                      </Form.Select>
                      {shift?.isOverLapping === 1 && (
                        <span className="text-danger">
                          Shift is overlapping
                        </span>
                      )}
                    </Form.Group>

                    <span className="mt-4 text-color-70">-</span>

                    {/* End Time */}
                    <Form.Group
                      controlId={`endTime-${index}`}
                      className="d-flex flex-column col-md-5"
                    >
                      <Form.Label className="fw-medium">End time</Form.Label>
                      <Form.Select
                        value={shift.end}
                        onChange={(e) =>
                          handleShiftChange(index, "end", e.target.value)
                        }
                        className="form-select"
                      >
                        {minHoursDropdown.map((min, i) => (
                          <option key={i} value={min.value}>
                            {min.label}
                          </option>
                        ))}
                      </Form.Select>
                      {shift?.isOverLapping === 1 && (
                        <span className="text-danger">
                          Shift is overlapping
                        </span>
                      )}
                    </Form.Group>

                    {/* Trash Icon */}
                    {/* <Trash
                      className="text-danger cursor-pointer mt-4"
                      onClick={() => handleDeleteShift(index, shift)}
                    /> */}
                    <button onClick={() => handleDeleteShift(index, shift)} className="btn btn-primary btn-sm d-flex align-items-center justify-content-center">  
                      <Trash
                        // className="text-danger cursor-pointer mt-4" 
                        />
                    </button>
                  </div>
                ))}

                {/* Add Shift and Total Hours */}
                <div className="d-flex justify-content-between align-items-center fs-6 fw-semibold">
                  <p
                    className="text-primary mb-0 d-flex align-items-center gap-2"
                    style={{ cursor: "pointer" }}
                    onClick={handleAddShift}
                  >
                    <PlusCircle /> <span>Add a shift</span>
                  </p>
                  <div className="text-color-70 align-center">{calculateTotalHours()}h</div>
                </div>

                {/* Action Buttons */}
                <div className="d-flex justify-content-between align-items-center mt-3">
                  {addEventData?.id > 0 && (
                    <div
                      className="btn btn-outline-primary btn-sm me-2 mb-2"
                      onClick={() => handleDeleteTeamShiftByDate()}
                    >
                      Delete
                    </div>
                  )} 
                  <div className="d-flex ms-auto gap-2">
                    <div
                      onClick={() => handleCloseOffCover()}
                      className="btn btn-outline-primary btn-sm me-3"
                    >
                      Cancel
                    </div>
                    <div
                      className="btn btn-primary btn-sm btn-wave me-2"
                      onClick={() => handleUpsertForStaff()}
                    >
                      Save
                    </div>
                  </div>
                </div>

                {/* till date Events */}
                {addEventData?.tillDate !==
                  moment(addEventData?.start).format("YYYY-MM-DD") && (
                  <div className="table-responsive mt-4">
                    <p className="custome-border-bottom ">
                      {addEventData?.slotName} shift{"'s"} till date{" "}
                      {dateFormat(addEventData?.tillDate)}
                    </p>
                    {shiftByTillDateList?.some(
                      (el) => el.isOverLapping === 1
                    ) && (
                      <span className="text-danger">
                        Note: Some shifts are overlapping
                      </span>
                    )}
                    <table className="table table-bordered">
                      <thead className="table-dark">
                        <tr>
                          <th>Date</th>
                          <th>StartTime</th>
                          <th>EndTime</th>
                        </tr>
                      </thead>
                      <tbody>
                        {shiftByTillDateList?.map((shift, index) => (
                          <tr key={index}>
                            <td>
                              {shift.isOverLapping === 1 && (
                                <Info
                                  width="16"
                                  className="text-danger"
                                  title="Shift is Overlapping"
                                />
                              )}{" "}
                              {dateFormat(shift.date)}
                            </td>
                            <td>{shift.start}</td>
                            <td>{shift.end}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </Form>
            </Offcanvas.Body>
          </>
        )}

        {/* this is day wise Shift */}
        {addEventData?.type == 2 && (
          <>
            <Offcanvas.Header closeButton>
              <Offcanvas.Title className="text-lg font-semibold">
                {addEventData?.slotName} Regular shift{" "}
              </Offcanvas.Title>
            </Offcanvas.Header>
            <StaffRegularShift
              minHoursDropdown={minHoursDropdown}
              daysDropdown={daysDropdown}
              resourceData={addEventData}
              businessId={businessId}
              callbackHandelCancle={handleCloseOffCover}
            />
          </>
        )}

        {/* this is day wise Shift */}
        {addEventData?.type == 3 && (
          <>
            <Offcanvas.Header closeButton>
              <Offcanvas.Title className="text-lg font-semibold">
                {addEventData?.slotName} Add Time Off{" "}
              </Offcanvas.Title>
            </Offcanvas.Header>
            <AddStaffBloackBreakTIme
              minHoursDropdown={minHoursDropdown}
              daysDropdown={daysDropdown}
              resourceData={addEventData}
              businessId={businessId}
              callbackHandelCancle={handleCloseOffCover}
              teamList={teamList}
            />
          </>
        )}
      </Offcanvas>
    </div>
  );
}

export default BusinessHoursTeamShiftManage;
